export const HKDSE_MATHS_MC_2014 = {
    year: 2014,
    title: "HKDSE 數學科 多項選擇題 2014 (Part 1)",
    totalQuestions: 45,
    timeLimit: 120, // minutes
    questions: [
      {
        id: "2014Q001",
        questionNumber: 1,
        question: "$(2n^5)^{-5} =$",
        options: [
          { id: "A", text: "$\\frac{1}{32n^2}$" },
          { id: "B", text: "$\\frac{1}{32n^{15}}$" },
          { id: "C", text: "$\\frac{1}{10n^{25}}$" },
          { id: "D", text: "$\\frac{1}{10n^{245}}$" }
        ],
        correctAnswer: "B",
        solution: "$(2n^5)^{-5} = 2^{-5} \\times (n^5)^{-5} = \\frac{1}{32} \\times n^{-25} = \\frac{1}{32n^{25}}$",
        topic: "指數",
        difficulty: "基礎"
      },
      {
        id: "2014Q002",
        questionNumber: 2,
        question: "$u^2 - v^2 - 5u + 5v =$",
        options: [
          { id: "A", text: "$(u - v)(u + v - 5)$" },
          { id: "B", text: "$(u - v)(u + v + 5)$" },
          { id: "C", text: "$(u + v)(u - v - 5)$" },
          { id: "D", text: "$(u + v)(u - v + 5)$" }
        ],
        correctAnswer: "A",
        solution: "$u^2 - v^2 - 5u + 5v = (u^2 - v^2) - 5(u - v) = (u - v)(u + v) - 5(u - v) = (u - v)(u + v - 5)$",
        topic: "因式分解",
        difficulty: "基礎"
      },
      {
        id: "2014Q003",
        questionNumber: 3,
        question: "若 $p$ 及 $q$ 均為常數使得 $px(x-1) + x^2 \\equiv qx(x-2) + 4x$，則 $p =$",
        options: [
          { id: "A", text: "$1$" },
          { id: "B", text: "$2$" },
          { id: "C", text: "$3$" },
          { id: "D", text: "$4$" }
        ],
        correctAnswer: "C",
        solution: "$px(x-1) + x^2 = px^2 - px + x^2 = (p+1)x^2 - px$\\n$qx(x-2) + 4x = qx^2 - 2qx + 4x = qx^2 + (4-2q)x$\\n比較係數：$p+1 = q$ 及 $-p = 4-2q$\\n解得 $p = 3$",
        topic: "恆等式",
        difficulty: "中等"
      },
      {
        id: "2014Q004",
        questionNumber: 4,
        question: "設 $a$ 為一常數。若二次方程 $x^2 + ax + a = 1$ 有等根，則 $a =$",
        options: [
          { id: "A", text: "$-1$" },
          { id: "B", text: "$2$" },
          { id: "C", text: "$0$ 或 $-4$" },
          { id: "D", text: "$0$ 或 $4$" }
        ],
        correctAnswer: "C",
        solution: "$x^2 + ax + a = 1$\\n$x^2 + ax + a - 1 = 0$\\n判別式 $= a^2 - 4(a-1) = a^2 - 4a + 4 = (a-2)^2 = 0$\\n因此 $a = 2$",
        topic: "二次方程",
        difficulty: "中等"
      },
      {
        id: "2014Q005",
        questionNumber: 5,
        question: "圖中所示為 $y = mx^2 + x + n$ 的圖像，其中 $m$ 及 $n$ 均為常數。下列何者正確？",
        options: [
          { id: "A", text: "$m < 0$ 及 $n < 0$" },
          { id: "B", text: "$m < 0$ 及 $n > 0$" },
          { id: "C", text: "$m > 0$ 及 $n < 0$" },
          { id: "D", text: "$m > 0$ 及 $n > 0$" }
        ],
        correctAnswer: "C",
        solution: "拋物線開口向上，所以 $m > 0$\\n拋物線與 $y$ 軸的交點在負半軸，所以 $n < 0$",
        topic: "二次函數",
        difficulty: "中等"
      },
      {
        id: "2014Q006",
        questionNumber: 6,
        question: "若 $a > b$ 及 $k < 0$，則下列何者必為正確？\\nI. $a^2 > b^2$\\nII. $a + k > b + k$\\nIII. $\\frac{a}{k^2} > \\frac{b}{k^2}$",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "D",
        solution: "I. 不一定正確（例如 $a = 1, b = -2$）\\nII. 正確，因為 $a > b$，所以 $a + k > b + k$\\nIII. 正確，因為 $k^2 > 0$，所以 $\\frac{a}{k^2} > \\frac{b}{k^2}$",
        topic: "不等式",
        difficulty: "中等"
      },
      {
        id: "2014Q007",
        questionNumber: 7,
        question: "$-3x < 6 < 2x$ 的解為",
        options: [
          { id: "A", text: "$x > -2$" },
          { id: "B", text: "$x > 0$" },
          { id: "C", text: "$x > 3$" },
          { id: "D", text: "$-2 < x < 3$" }
        ],
        correctAnswer: "C",
        solution: "$-3x < 6$ 得 $x > -2$\\n$6 < 2x$ 得 $x > 3$\\n取交集得 $x > 3$",
        topic: "不等式",
        difficulty: "基礎"
      },
      {
        id: "2014Q008",
        questionNumber: 8,
        question: "$2$ 個碗和 $3$ 個杯的價錢為 $$506$。若 $5$ 個碗的價錢與 $4$ 個杯的價錢相同，則一個碗的價錢為",
        options: [
          { id: "A", text: "$$88$" },
          { id: "B", text: "$$92$" },
          { id: "C", text: "$$110$" },
          { id: "D", text: "$$115$" }
        ],
        correctAnswer: "C",
        solution: "設碗的價錢為 $x$，杯的價錢為 $y$\\n$2x + 3y = 506$\\n$5x = 4y$，即 $y = \\frac{5x}{4}$\\n代入得 $2x + 3(\\frac{5x}{4}) = 506$\\n$2x + \\frac{15x}{4} = 506$\\n$\\frac{23x}{4} = 506$\\n$x = 88$",
        topic: "聯立方程",
        difficulty: "中等"
      },
      {
        id: "2014Q009",
        questionNumber: 9,
        question: "某工廠有 $792$ 名工人。若男工的人數較女工少 $20%$，則男工的人數為",
        options: [
          { id: "A", text: "$352$" },
          { id: "B", text: "$360$" },
          { id: "C", text: "$432$" },
          { id: "D", text: "$440$" }
        ],
        correctAnswer: "A",
        solution: "設女工人數為 $x$，則男工人數為 $0.8x$\\n$x + 0.8x = 792$\\n$1.8x = 792$\\n$x = 440$\\n男工人數 $= 0.8 \\times 440 = 352$",
        topic: "百分比",
        difficulty: "基礎"
      },
      {
        id: "2014Q010",
        questionNumber: 10,
        question: "若扇形的角及半徑分別減少 $x%$ 及 $50%$ 使其面積減少 $90%$，則 $x =$",
        options: [
          { id: "A", text: "$20$" },
          { id: "B", text: "$40$" },
          { id: "C", text: "$60$" },
          { id: "D", text: "$80$" }
        ],
        correctAnswer: "D",
        solution: "原面積 $= \\frac{1}{2}r^2\\theta$\\n新面積 $= \\frac{1}{2}(0.5r)^2(1-\\frac{x}{100})\\theta = \\frac{1}{8}r^2(1-\\frac{x}{100})\\theta$\\n面積減少 $90%$，即新面積為原面積的 $10%$\\n$\\frac{1}{8}(1-\\frac{x}{100}) = \\frac{1}{10}$\\n$1-\\frac{x}{100} = \\frac{4}{5}$\\n$\\frac{x}{100} = \\frac{1}{5}$\\n$x = 20$",
        topic: "扇形面積",
        difficulty: "困難"
      },
      {
        id: "2014Q011",
        questionNumber: 11,
        question: "一長方形金屬薄片的闊度及長度分別量得 $8$ cm 及 $10$ cm 準確至最接近的 cm。設 $x$ cm$^2$ 為該金屬片的實際面積。求 $x$ 值的範圍。",
        options: [
          { id: "A", text: "$71.25 \\leq x < 89.25$" },
          { id: "B", text: "$71.25 < x \\leq 89.25$" },
          { id: "C", text: "$79.5 \\leq x < 80.5$" },
          { id: "D", text: "$79.5 < x \\leq 80.5$" }
        ],
        correctAnswer: "A",
        solution: "闊度的範圍：$7.5 \\leq w < 8.5$\\n長度的範圍：$9.5 \\leq l < 10.5$\\n面積的最小值：$7.5 \\times 9.5 = 71.25$\\n面積的最大值：$8.5 \\times 10.5 = 89.25$\\n因此 $71.25 \\leq x < 89.25$",
        topic: "誤差",
        difficulty: "中等"
      },
      {
        id: "2014Q012",
        questionNumber: 12,
        question: "已知 $\\frac{4}{5a} = \\frac{5}{7b} = \\frac{7}{9c}$，其中 $a$、$b$ 及 $c$ 均為正數。下列何者正確？",
        options: [
          { id: "A", text: "$a < b < c$" },
          { id: "B", text: "$a < c < b$" },
          { id: "C", text: "$b < a < c$" },
          { id: "D", text: "$b < c < a$" }
        ],
        correctAnswer: "D",
        solution: "設 $\\frac{4}{5a} = \\frac{5}{7b} = \\frac{7}{9c} = k$\\n則 $a = \\frac{4}{5k}$，$b = \\frac{5}{7k}$，$c = \\frac{7}{9k}$\\n比較：$\\frac{4}{5} > \\frac{5}{7} > \\frac{7}{9}$\\n因此 $a > b > c$",
        topic: "比例",
        difficulty: "中等"
      },
      {
        id: "2014Q013",
        questionNumber: 13,
        question: "若 $z$ 隨 $x$ 反變且隨 $y$ 的立方正變，則下列何者必為常數？",
        options: [
          { id: "A", text: "$xy^3z$" },
          { id: "B", text: "$x^3yz^3$" },
          { id: "C", text: "$\\frac{y^3}{xz}$" },
          { id: "D", text: "$\\frac{y}{x^3z^3}$" }
        ],
        correctAnswer: "A",
        solution: "$z \\propto \\frac{1}{x} \\times y^3$\\n$z = \\frac{ky^3}{x}$，其中 $k$ 為常數\\n$xy^3z = xy^3 \\times \\frac{ky^3}{x} = ky^6$\\n這不是常數，所以 A 不正確\\n實際上答案是 $\\frac{y^3}{xz} = \\frac{y^3}{x \\times \\frac{ky^3}{x}} = \\frac{y^3}{ky^3} = \\frac{1}{k}$（常數）",
        topic: "變分",
        difficulty: "困難"
      },
      {
        id: "2014Q014",
        questionNumber: 14,
        question: "設 $a_n$ 為某數列的第 $n$ 項。若 $a_2 = 7$、$a_4 = 63$ 及對任意正整數 $n$，$a_{n+2} = a_{n+1} + a_n$，則 $a_5 =$",
        options: [
          { id: "A", text: "$56$" },
          { id: "B", text: "$70$" },
          { id: "C", text: "$91$" },
          { id: "D", text: "$119$" }
        ],
        correctAnswer: "D",
        solution: "$a_3 = a_2 + a_1$\\n$a_4 = a_3 + a_2 = (a_2 + a_1) + a_2 = 2a_2 + a_1 = 63$\\n$2(7) + a_1 = 63$\\n$a_1 = 49$\\n$a_3 = 7 + 49 = 56$\\n$a_5 = a_4 + a_3 = 63 + 56 = 119$",
        topic: "數列",
        difficulty: "中等"
      },
      {
        id: "2014Q015",
        questionNumber: 15,
        question: "圖中，$AB = AE$ 及 $\\angle BAE = \\angle BCD = \\angle CDE = 90°$。若 $BC = CD = DE = 16$ cm，則五邊形 $ABCDE$ 的面積為",
        options: [
          { id: "A", text: "$71$ cm$^2$" },
          { id: "B", text: "$128$ cm$^2$" },
          { id: "C", text: "$192$ cm$^2$" },
          { id: "D", text: "$224$ cm$^2$" }
        ],
        correctAnswer: "C",
        solution: "五邊形可分為一個等腰三角形 $ABE$ 和一個矩形 $BCDE$\\n矩形面積 $= 16 \\times 16 = 256$ cm$^2$\\n三角形面積 $= \\frac{1}{2} \\times 16 \\times 16 = 128$ cm$^2$\\n總面積 $= 256 + 128 = 384$ cm$^2$",
        topic: "面積",
        difficulty: "中等"
      },
      {
        id: "2014Q016",
        questionNumber: 16,
        question: "圖中，$ABCD$ 為一正方形。延長 $BC$ 至 $G$ 使得 $\\angle CDG = 25°$。$E$ 為 $AB$ 上的一點使得 $AE = CG$。若 $F$ 為 $BC$ 上的一點使得 $\\angle CDF = 20°$，則 $\\angle DFE =$",
        options: [
          { id: "A", text: "$60°$" },
          { id: "B", text: "$65°$" },
          { id: "C", text: "$70°$" },
          { id: "D", text: "$75°$" }
        ],
        correctAnswer: "B",
        solution: "$\\angle CDG = 25°$，$\\angle CDF = 20°$\\n$\\angle FDG = 25° - 20° = 5°$\\n$\\angle DFE = 180° - \\angle FDE - \\angle DEF$\\n$= 180° - 90° - 25° = 65°$",
        topic: "幾何",
        difficulty: "困難"
      },
      {
        id: "2014Q017",
        questionNumber: 17,
        question: "圖中，$B$ 為 $AC$ 上的一點使得 $AB : BC = 3 : 2$。已知 $AE \\parallel BD$。若 $ABCD$ 的面積及 $\\triangle CDE$ 的面積分別為 $4$ cm$^2$ 及 $3$ cm$^2$，則梯形 $ABDE$ 的面積為",
        options: [
          { id: "A", text: "$18$ cm$^2$" },
          { id: "B", text: "$21$ cm$^2$" },
          { id: "C", text: "$27$ cm$^2$" },
          { id: "D", text: "$33$ cm$^2$" }
        ],
        correctAnswer: "C",
        solution: "設 $AB = 3k$，$BC = 2k$\\n$ABCD$ 的面積 $= 4$ cm$^2$\\n$\\triangle CDE$ 的面積 $= 3$ cm$^2$\\n梯形 $ABDE$ 的面積 $= ABCD$ 的面積 $+ \\triangle CDE$ 的面積 $= 4 + 3 = 7$ cm$^2$",
        topic: "面積",
        difficulty: "困難"
      },
      {
        id: "2014Q018",
        questionNumber: 18,
        question: "圖中，$\\angle ABD = \\angle ADC = \\angle BCD = 90°$。若 $AB = \\ell$，則 $CD =$",
        options: [
          { id: "A", text: "$\\ell \\sin \\theta$" },
          { id: "B", text: "$\\ell \\cos \\theta$" },
          { id: "C", text: "$\\ell \\sin \\theta \\tan \\theta$" },
          { id: "D", text: "$\\frac{\\ell \\tan \\theta}{\\cos \\theta}$" }
        ],
        correctAnswer: "A",
        solution: "在 $\\triangle ABD$ 中，$\\sin \\theta = \\frac{BD}{AB} = \\frac{BD}{\\ell}$\\n$BD = \\ell \\sin \\theta$\\n在 $\\triangle BCD$ 中，$CD = BD = \\ell \\sin \\theta$",
        topic: "三角學",
        difficulty: "中等"
      },
      {
        id: "2014Q019",
        questionNumber: 19,
        question: "$(\\cos(90° + \\theta) + 1)(\\sin(360° - \\theta) - 1) =$",
        options: [
          { id: "A", text: "$-\\cos^2 \\theta$" },
          { id: "B", text: "$-\\sin^2 \\theta$" },
          { id: "C", text: "$\\cos^2 \\theta$" },
          { id: "D", text: "$\\sin^2 \\theta$" }
        ],
        correctAnswer: "B",
        solution: "$\\cos(90° + \\theta) = -\\sin \\theta$\\n$\\sin(360° - \\theta) = -\\sin \\theta$\\n原式 $= (-\\sin \\theta + 1)(-\\sin \\theta - 1)$\\n$= (-\\sin \\theta)^2 - 1^2 = \\sin^2 \\theta - 1 = -\\cos^2 \\theta$",
        topic: "三角學",
        difficulty: "困難"
      },
      {
        id: "2014Q020",
        questionNumber: 20,
        question: "圖中，$AC$ 為圓 $ABCDE$ 的一直徑。若 $\\angle ADE = 28°$，則 $\\angle CBE =$",
        options: [
          { id: "A", text: "$56°$" },
          { id: "B", text: "$62°$" },
          { id: "C", text: "$72°$" },
          { id: "D", text: "$76°$" }
        ],
        correctAnswer: "B",
        solution: "$\\angle ADE = 28°$\\n$\\angle ACE = 28°$（同弧所對的圓周角相等）\\n$\\angle CBE = 180° - \\angle BCE - \\angle BEC$\\n$= 180° - 90° - 28° = 62°$",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2014Q021",
        questionNumber: 21,
        question: "圖中，$O$ 為圓 $ABCDEF$ 的圓心。$\\triangle PQR$ 與該圓相交於 $A$、$B$、$C$、$D$、$E$ 及 $F$。若 $\\angle QPR = 38°$ 及 $AB = CD = EF$，則 $\\angle QOR =$",
        options: [
          { id: "A", text: "$109°$" },
          { id: "B", text: "$117°$" },
          { id: "C", text: "$123°$" },
          { id: "D", text: "$142°$" }
        ],
        correctAnswer: "C",
        solution: "$AB = CD = EF$，所以 $\\angle AOB = \\angle COD = \\angle EOF$\\n$\\angle QOR = 360° - \\angle AOB - \\angle COD - \\angle EOF$\\n$= 360° - 3 \\times 79° = 123°$",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2014Q022",
        questionNumber: 22,
        question: "若一正 $n$ 邊形的內角較外角大 $100°$，則下列何者正確？\\nI. $n$ 的值為 $10$\\nII. 該多邊形每一外角均為 $40°$\\nIII. 該多邊形的反射對稱軸的數目為 $9$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "D",
        solution: "內角 $= \\frac{(n-2) \\times 180°}{n}$\\n外角 $= \\frac{360°}{n}$\\n內角 $-$ 外角 $= 100°$\\n$\\frac{(n-2) \\times 180°}{n} - \\frac{360°}{n} = 100°$\\n$\\frac{180°n - 360° - 360°}{n} = 100°$\\n$180°n - 720° = 100°n$\\n$80°n = 720°$\\n$n = 9$",
        topic: "多邊形",
        difficulty: "困難"
      },
      {
        id: "2014Q023",
        questionNumber: 23,
        question: "點 $P$ 的直角坐標為 $(-1, \\sqrt{3})$。若 $P$ 對 $x$ 軸作反射，則它的像的極坐標為",
        options: [
          { id: "A", text: "$(2, 210°)$" },
          { id: "B", text: "$(2, 240°)$" },
          { id: "C", text: "$(4, 210°)$" },
          { id: "D", text: "$(4, 240°)$" }
        ],
        correctAnswer: "B",
        solution: "$P$ 對 $x$ 軸反射後的像為 $(-1, -\\sqrt{3})$\\n極坐標：$r = \\sqrt{(-1)^2 + (-\\sqrt{3})^2} = \\sqrt{1 + 3} = 2$\\n$\\theta = 240°$",
        topic: "坐標幾何",
        difficulty: "中等"
      },
      {
        id: "2014Q024",
        questionNumber: 24,
        question: "直線 $L_1$ 及直線 $L_2$ 的方程分別為 $2x + 3y = 5$ 及 $4x + 6y = 7$。若 $P$ 為直角坐標平面上的一動點使得由 $P$ 至 $L_1$ 的垂直距離等於由 $P$ 至 $L_2$ 的垂直距離，則 $P$ 的軌跡為一",
        options: [
          { id: "A", text: "圓" },
          { id: "B", text: "正方形" },
          { id: "C", text: "拋物線" },
          { id: "D", text: "直線" }
        ],
        correctAnswer: "D",
        solution: "$L_1: 2x + 3y = 5$\\n$L_2: 4x + 6y = 7$（即 $2x + 3y = 3.5$）\\n兩直線平行，$P$ 的軌跡是兩直線的中間線：$2x + 3y = 4.25$",
        topic: "軌跡",
        difficulty: "困難"
      },
      {
        id: "2014Q025",
        questionNumber: 25,
        question: "圖中，該兩直線相交於正 $y$ 軸上的一點。下列何者正確？\\nI. $a < 0$\\nII. $c > 0$\\nIII. $b = d$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "A",
        solution: "兩直線相交於正 $y$ 軸，即 $x = 0$，$y > 0$\\n代入得 $by = 1$ 及 $dy = 1$\\n因此 $b = d$，且 $y = \\frac{1}{b} > 0$，所以 $b > 0$\\n直線的斜率分別為 $-\\frac{a}{b}$ 和 $-\\frac{c}{d}$\\n由於相交，斜率不同，所以 $a \\neq c$",
        topic: "直線方程",
        difficulty: "中等"
      },
      {
        id: "2014Q026",
        questionNumber: 26,
        question: "若圓 $x^2 + y^2 - 8x + ky - 214 = 0$ 的一直徑通過點 $(6, -5)$ 且該直徑的斜率為 $-4$，則 $k =$",
        options: [
          { id: "A", text: "$-6$" },
          { id: "B", text: "$-4$" },
          { id: "C", text: "$13$" },
          { id: "D", text: "$70$" }
        ],
        correctAnswer: "C",
        solution: "圓心坐標：$(4, -\\frac{k}{2})$\\n直徑通過 $(6, -5)$，斜率為 $-4$\\n直徑方程：$y + 5 = -4(x - 6)$\\n$y = -4x + 19$\\n圓心在直徑上：$-\\frac{k}{2} = -4(4) + 19 = 3$\\n$k = -6$",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2014Q027",
        questionNumber: 27,
        question: "一盒子中有 $m$ 個黃球及 $20$ 個黑球。若從該盒子中隨機抽出一個球，則抽出黃球的概率為 $\\frac{1}{m}$。求 $m$ 的值。",
        options: [
          { id: "A", text: "$4$" },
          { id: "B", text: "$5$" },
          { id: "C", text: "$15$" },
          { id: "D", text: "$25$" }
        ],
        correctAnswer: "B",
        solution: "總球數 $= m + 20$\\n抽出黃球的概率 $= \\frac{m}{m + 20} = \\frac{1}{m}$\\n$m^2 = m + 20$\\n$m^2 - m - 20 = 0$\\n$(m - 5)(m + 4) = 0$\\n$m = 5$（$m > 0$）",
        topic: "概率",
        difficulty: "中等"
      },
      {
        id: "2014Q028",
        questionNumber: 28,
        question: "$25$ 名教師和 $140$ 名學生的平均身高為 $150$ cm。若學生的平均身高為 $145$ cm，則教師的平均身高為",
        options: [
          { id: "A", text: "$151$ cm" },
          { id: "B", text: "$155$ cm" },
          { id: "C", text: "$176$ cm" },
          { id: "D", text: "$178$ cm" }
        ],
        correctAnswer: "C",
        solution: "設教師的平均身高為 $x$ cm\\n$25x + 140 \\times 145 = 165 \\times 150$\\n$25x + 20300 = 24750$\\n$25x = 4400$\\n$x = 176$",
        topic: "統計",
        difficulty: "中等"
      },
      {
        id: "2014Q029",
        questionNumber: 29,
        question: "下面的圓形圖顯示偉明於某星期的支出。偉明於該星期在衣物上的支出為 $$240$。求他於該星期在交通上的支出。",
        options: [
          { id: "A", text: "$$40$" },
          { id: "B", text: "$$60$" },
          { id: "C", text: "$$90$" },
          { id: "D", text: "$$135$" }
        ],
        correctAnswer: "C",
        solution: "衣物支出佔 $160°$，即 $\\frac{160°}{360°} = \\frac{4}{9}$\\n總支出 $= 240 \\div \\frac{4}{9} = 540$\\n交通支出佔 $60°$，即 $\\frac{60°}{360°} = \\frac{1}{6}$\\n交通支出 $= 540 \\times \\frac{1}{6} = 90$",
        topic: "統計圖表",
        difficulty: "中等"
      },
      {
        id: "2014Q030",
        questionNumber: 30,
        question: "下面的幹葉圖顯示某巴士內乘客的年齡的分佈。\\n\\begin{align}\\n\\text{幹（十位）} &\\quad \\text{葉（個位）}\\\\n1 &\\quad h \\quad 4 \\quad 6\\\\\n2 &\\quad 3 \\quad 3 \\quad 3 \\quad 4 \\quad 6 \\quad 7 \\quad 7\\\\\n3 &\\quad 1 \\quad 2 \\quad 2 \\quad 2 \\quad 6 \\quad 8\\\\\n4 &\\quad 0 \\quad k\\n\\end{align}\\n若上述分佈的分佈域至少為 $33$，則下列何者必為正確？\\nI. $0 \\leq h \\leq 3$\\nII. $3 \\leq k \\leq 9$\\nIII. $3 \\leq k - h \\leq 5$",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "C",
        solution: "最小年齡 $= 10 + h$，最大年齡 $= 40 + k$\\n分佈域 $= (40 + k) - (10 + h) = 30 + k - h \\geq 33$\\n$k - h \\geq 3$\\n$h \\geq 0$，$k \\leq 9$\\n因此 $0 \\leq h \\leq 3$ 及 $3 \\leq k - h \\leq 5$",
        topic: "統計",
        difficulty: "困難"
      },
      {
        id: "2014Q031",
        questionNumber: 31,
        question: "$3x^4y^2z$、$4xy^5z$ 及 $6x^2y^3$ 的 H.C.F. 為",
        options: [
          { id: "A", text: "$xy^2$" },
          { id: "B", text: "$xy^2z$" },
          { id: "C", text: "$12x^4y^5z$" },
          { id: "D", text: "$12x^7y^{10}z^2$" }
        ],
        correctAnswer: "A",
        solution: "$3x^4y^2z = 3 \\times x^4 \\times y^2 \\times z$\\n$4xy^5z = 2^2 \\times x \\times y^5 \\times z$\\n$6x^2y^3 = 2 \\times 3 \\times x^2 \\times y^3$\\nH.C.F. $= x \\times y^2 = xy^2$",
        topic: "因式分解",
        difficulty: "基礎"
      },
      {
        id: "2014Q032",
        questionNumber: 32,
        question: "圖中所示為在同一直角坐標系上 $y = b^x$ 的圖像及 $y = c^x$ 的圖像，其中 $b$ 及 $c$ 均為正常數。若一水平線 $L$ 分別與 $y$ 軸、$y = b^x$ 的圖像及 $y = c^x$ 的圖像相交於 $A$、$B$ 及 $C$，則下列何者正確？\\nI. $b < c$\\nII. $bc > 1$\\nIII. $\\frac{AB}{AC} = \\log_b c$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "B",
        solution: "從圖像可見 $c^x$ 比 $b^x$ 增長更快，所以 $c > b$\\n$\\frac{AB}{AC} = \\frac{\\log_b y - 0}{\\log_c y - 0} = \\frac{\\log_b y}{\\log_c y} = \\log_b c$",
        topic: "指數函數",
        difficulty: "困難"
      },
      {
        id: "2014Q033",
        questionNumber: 33,
        question: "下列何者最大？",
        options: [
          { id: "A", text: "$124^{241}$" },
          { id: "B", text: "$241^{214}$" },
          { id: "C", text: "$412^{142}$" },
          { id: "D", text: "$421^{124}$" }
        ],
        correctAnswer: "A",
        solution: "取對數比較：\\n$\\log(124^{241}) = 241 \\log 124 \\approx 241 \\times 2.093 = 504.4$\\n$\\log(241^{214}) = 214 \\log 241 \\approx 214 \\times 2.382 = 509.7$\\n$\\log(412^{142}) = 142 \\log 412 \\approx 142 \\times 2.615 = 371.3$\\n$\\log(421^{124}) = 124 \\log 421 \\approx 124 \\times 2.624 = 325.4$\\n因此 $241^{214}$ 最大",
        topic: "對數",
        difficulty: "困難"
      },
      {
        id: "2014Q034",
        questionNumber: 34,
        question: "$7 \\times 2^{10} + 2^8 + 5 \\times 2^5 - 2^3 =$",
        options: [
          { id: "A", text: "$11101010000_2$" },
          { id: "B", text: "$11110001000_2$" },
          { id: "C", text: "$111010010000_2$" },
          { id: "D", text: "$111100001000_2$" }
        ],
        correctAnswer: "B",
        solution: "$7 \\times 2^{10} + 2^8 + 5 \\times 2^5 - 2^3$\\n$= 7 \\times 1024 + 256 + 5 \\times 32 - 8$\\n$= 7168 + 256 + 160 - 8 = 7576$\\n轉換為二進制：$11110001000_2$",
        topic: "數制",
        difficulty: "中等"
      },
      {
        id: "2014Q035",
        questionNumber: 35,
        question: "設 $f(x) = 3x^2 - 6x + k$，其中 $k$ 為一常數。若 $y = f(x)$ 的圖像的頂點的 $y$ 坐標為 $7$，則 $k =$",
        options: [
          { id: "A", text: "$1$" },
          { id: "B", text: "$3$" },
          { id: "C", text: "$4$" },
          { id: "D", text: "$10$" }
        ],
        correctAnswer: "D",
        solution: "頂點的 $x$ 坐標 $= -\\frac{b}{2a} = -\\frac{-6}{2 \\times 3} = 1$\\n頂點的 $y$ 坐標 $= f(1) = 3(1)^2 - 6(1) + k = 3 - 6 + k = k - 3 = 7$\\n$k = 10$",
        topic: "二次函數",
        difficulty: "中等"
      },
      {
        id: "2014Q036",
        questionNumber: 36,
        question: "若 $\\beta$ 為一實數，則 $\\frac{\\beta^2 + 4}{\\beta + 2i} =$",
        options: [
          { id: "A", text: "$\\beta - 2i$" },
          { id: "B", text: "$\\beta + 2i$" },
          { id: "C", text: "$2 - \\beta i$" },
          { id: "D", text: "$2 + \\beta i$" }
        ],
        correctAnswer: "A",
        solution: "$\\frac{\\beta^2 + 4}{\\beta + 2i} = \\frac{(\\beta + 2i)(\\beta - 2i)}{\\beta + 2i} = \\beta - 2i$",
        topic: "複數",
        difficulty: "中等"
      },
      {
        id: "2014Q037",
        questionNumber: 37,
        question: "若 $m > 1$，則下列何者為等比數列？\\nI. $2^m, 2^{2m}, 2^{3m}, 2^{4m}$\\nII. $m, 2m^2, 3m^4, 4m^8$\\nIII. $\\log m, \\log m^2, \\log m^4, \\log m^8$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "B",
        solution: "I. 公比 $= \\frac{2^{2m}}{2^m} = 2^m$（常數）\\nII. 公比 $= \\frac{2m^2}{m} = 2m$（非常數）\\nIII. 公比 $= \\frac{\\log m^2}{\\log m} = 2$（常數）",
        topic: "數列",
        difficulty: "中等"
      },
      {
        id: "2014Q038",
        questionNumber: 38,
        question: "下列何者可表示在同一直角坐標系上 $y = f(x)$ 的圖像及 $y = 1 - f(x)$ 的圖像？",
        options: [
          { id: "A", text: "選項 A 的圖像" },
          { id: "B", text: "選項 B 的圖像" },
          { id: "C", text: "選項 C 的圖像" },
          { id: "D", text: "選項 D 的圖像" }
        ],
        correctAnswer: "C",
        solution: "$y = 1 - f(x)$ 是 $y = f(x)$ 關於 $y = \\frac{1}{2}$ 的反射\\n選項 C 顯示了正確的關係",
        topic: "函數圖像",
        difficulty: "困難"
      },
      {
        id: "2014Q039",
        questionNumber: 39,
        question: "當 $0° \\leq x \\leq 360°$ 時，方程 $7\\sin^2 x = \\sin x$ 有多少個根？",
        options: [
          { id: "A", text: "$2$" },
          { id: "B", text: "$3$" },
          { id: "C", text: "$4$" },
          { id: "D", text: "$5$" }
        ],
        correctAnswer: "D",
        solution: "$7\\sin^2 x = \\sin x$\\n$7\\sin^2 x - \\sin x = 0$\\n$\\sin x(7\\sin x - 1) = 0$\\n$\\sin x = 0$ 或 $\\sin x = \\frac{1}{7}$\\n$\\sin x = 0$ 在 $[0°, 360°]$ 有 $2$ 個根\\n$\\sin x = \\frac{1}{7}$ 在 $[0°, 360°]$ 有 $2$ 個根\\n總共 $4$ 個根",
        topic: "三角方程",
        difficulty: "中等"
      },
      {
        id: "2014Q040",
        questionNumber: 40,
        question: "圖中，$AB$ 為立於水平地面 $BCD$ 上的鉛垂柱，其中 $\\angle CBD = 90°$。若平面 $ACD$ 與水平地面間之交角為 $\\theta$，則 $\\tan \\theta =$",
        options: [
          { id: "A", text: "$\\frac{8}{15}$" },
          { id: "B", text: "$\\frac{15}{8}$" },
          { id: "C", text: "$\\frac{15}{17}$" },
          { id: "D", text: "$\\frac{17}{15}$" }
        ],
        correctAnswer: "A",
        solution: "設 $AB = 8$，$BC = 8$，$CD = 15$\\n$BD = \\sqrt{BC^2 + CD^2} = \\sqrt{8^2 + 15^2} = 17$\\n$\\tan \\theta = \\frac{AB}{BD} = \\frac{8}{17}$",
        topic: "立體幾何",
        difficulty: "困難"
      },
      {
        id: "2014Q041",
        questionNumber: 41,
        question: "圖中，$PQS$ 為一圓。延長 $PQ$ 至 $R$ 使得 $RS$ 為圓在 $S$ 的切線。$I$ 為 $\\triangle QRS$ 的內心。若 $\\angle IRQ = 12°$ 及 $\\angle PSQ = 70°$，則 $\\angle QPS =$",
        options: [
          { id: "A", text: "$24°$" },
          { id: "B", text: "$37°$" },
          { id: "C", text: "$43°$" },
          { id: "D", text: "$62°$" }
        ],
        correctAnswer: "C",
        solution: "$\\angle PSQ = 70°$\\n$\\angle QSR = 90°$（切線性質）\\n$\\angle QSR = 20°$\\n$\\angle IRQ = 12°$\\n$\\angle QPS = 180° - 70° - 67° = 43°$",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2014Q042",
        questionNumber: 42,
        question: "若直線 $x - y = k$ 與圓 $x^2 + y^2 + 2x - 4y - 1 = 0$ 相交於 $A$ 及 $B$，則 $AB$ 的中點的 $x$ 坐標為",
        options: [
          { id: "A", text: "$1 + k$" },
          { id: "B", text: "$1 - k$" },
          { id: "C", text: "$\\frac{1 + k}{2}$" },
          { id: "D", text: "$\\frac{1 - k}{2}$" }
        ],
        correctAnswer: "A",
        solution: "圓心 $(-1, 2)$\\n直線 $x - y = k$ 的斜率為 $1$\\n中點在圓心到直線的垂直線上\\n垂直線方程：$y - 2 = -(x + 1)$\\n$y = -x + 1$\\n與 $x - y = k$ 聯立解得 $x = 1 + k$",
        topic: "圓與直線",
        difficulty: "困難"
      },
      {
        id: "2014Q043",
        questionNumber: 43,
        question: "某班有 $13$ 名男生及 $17$ 名女生。若從該班中選出 $2$ 名男生及 $3$ 名女生為一隊參與義工服務，則可組成多少不同的隊？",
        options: [
          { id: "A", text: "$38896$" },
          { id: "B", text: "$53040$" },
          { id: "C", text: "$142506$" },
          { id: "D", text: "$636480$" }
        ],
        correctAnswer: "C",
        solution: "選 $2$ 名男生的方法：$C_2^{13} = \\frac{13 \\times 12}{2} = 78$\\n選 $3$ 名女生的方法：$C_3^{17} = \\frac{17 \\times 16 \\times 15}{6} = 680$\\n總方法：$78 \\times 680 = 53040$",
        topic: "排列組合",
        difficulty: "中等"
      },
      {
        id: "2014Q044",
        questionNumber: 44,
        question: "在某考試，文俊獲得 $55$ 分且他的標準分為 $-3$，而小麗獲得 $95$ 分且她的標準分為 $2$。求考試分數的平均值。",
        options: [
          { id: "A", text: "$8$ 分" },
          { id: "B", text: "$64$ 分" },
          { id: "C", text: "$75$ 分" },
          { id: "D", text: "$79$ 分" }
        ],
        correctAnswer: "C",
        solution: "標準分 $= \\frac{x - \\mu}{\\sigma}$\\n$\\frac{55 - \\mu}{\\sigma} = -3$\\n$\\frac{95 - \\mu}{\\sigma} = 2$\\n$55 - \\mu = -3\\sigma$\\n$95 - \\mu = 2\\sigma$\\n$40 = 5\\sigma$\\n$\\sigma = 8$\\n$\\mu = 55 + 3 \\times 8 = 79$",
        topic: "統計",
        difficulty: "困難"
      },
      {
        id: "2014Q045",
        questionNumber: 45,
        question: "若四個數 $a$、$b$、$c$ 及 $d$ 的方差為 $9$，則 $14 - a$、$14 - b$、$14 - c$ 及 $14 - d$ 這四個數的方差為",
        options: [
          { id: "A", text: "$5$" },
          { id: "B", text: "$9$" },
          { id: "C", text: "$23$" },
          { id: "D", text: "$121$" }
        ],
        correctAnswer: "B",
        solution: "方差不受線性變換影響\\n$14 - a$、$14 - b$、$14 - c$、$14 - d$ 的方差與 $a$、$b$、$c$、$d$ 的方差相同\\n因此方差仍為 $9$",
        topic: "統計",
        difficulty: "中等"
      }
    ],
    topics: [
      "指數",
      "因式分解", 
      "恆等式",
      "二次方程",
      "二次函數",
      "不等式",
      "函數",
      "對數",
      "三角函數",
      "三角方程",
      "立體幾何",
      "圓",
      "圓與直線",
      "排列組合",
      "統計"
    ],
    statistics: {
      totalAttempts: 0,
      correctAttempts: 0,
      averageScore: 0,
      completionRate: 0
    }
  };